export * from '@taqueria/protocol/out/types/PluginProxyResponse';
